import { CONTACT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { shouldRightAlignProperty } from '../../utils/shouldRightAlignProperty';
import TruncateDiv from '../TruncateDiv';
import { jsx as _jsx } from "react/jsx-runtime";
const LabelHeaderContent = ({
  objectTypeId,
  propertyDefinition
}) => /*#__PURE__*/_jsx(TruncateDiv, {
  rightAligned: shouldRightAlignProperty(propertyDefinition),
  children: objectTypeId === CONTACT_TYPE_ID ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "datatable.labelCell.contactHeader"
  }) : propertyDefinition && (propertyDefinition.label || propertyDefinition.name)
});
export default LabelHeaderContent;